import React from 'react';
import { EmptyCollection } from './EmptyCollection';
import { Button } from 'components/Button/Button';

import breaker1 from '../../assets/img/break22.jpg';
import breaker2 from '../../assets/img/break23.jpg';
import breaker3 from '../../assets/img/break24.jpg';
import breaker4 from '../../assets/img/break25.jpg';
import breaker5 from '../../assets/img/break26.jpg';

import OpenSeaIcon from 'components/Components/OpeanSea';
import AccountBreaker from './AccountBreaker';
import { useBreakerData } from 'hooks/useBreakerData';
import Spinner from '../Spinner';

type BreakerData = {
  isLoadingBreakerData: boolean;
  myBreakers: any[];
  selectedBreaker: any;
  setSelectedBreakerMoralis: (breaker: any) => Promise<void>;
};

const placeholderImages = [breaker1, breaker2, breaker3, breaker4, breaker5];

export function BreakerCollection() {
  const {
    myBreakers,
    isLoadingBreakerData,
    selectedBreaker,
    setSelectedBreakerMoralis,
  }: BreakerData = useBreakerData();

  if (isLoadingBreakerData) {
    return (
      <div className="breaker-collection">
        <div className="mt-5 text-center">
          <Spinner color="white" width={30} height={30} />
        </div>
      </div>
    );
  }

  return (
    <div className="breaker-collection">
      {myBreakers.length === 0 ? (
        <div className="mt-5">
          <EmptyCollection
            title="Get your first Breaker and enter the Dusk"
            message="You don’t own any Breakers yet."
            placeholderImages={placeholderImages}
          >
            <a className="nav-link text-center" href="https://opensea.io/collection/duskbreakers">
              <Button primary>
                <OpenSeaIcon /> Buy now on opensea
              </Button>
            </a>
          </EmptyCollection>
        </div>
      ) : (
        <div>
          <div>
            <h2>Your roster includes {myBreakers.length} Breaker(s)</h2>
            {!selectedBreaker && myBreakers.length > 0 && (
              <p>
                Click to <span className="text-highlight">Activate a Breaker </span> and power up
                your gaming experience.
              </p>
            )}
          </div>
          <div className="breaker-list">
            {myBreakers.map((breaker) => {
              return (
                <div key={breaker.token_id}>
                  <AccountBreaker
                    breaker={breaker}
                    isSelected={breaker.token_id === selectedBreaker?.token_id}
                    onClick={() => {
                      setSelectedBreakerMoralis(breaker);
                    }}
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
